import React, { useEffect } from "react";
// import "../../global.scss";
import "../Booking/feedback.scss";
import { IonRow, IonCol, IonText, IonLabel, IonModal, IonInput, IonButton } from "@ionic/react";
import { connect } from "react-redux";
import { clearSavedFeedbackStatus, fetchBookings, saveFeedback } from "../../../Store/Actions";
import { ToastMessage } from "../../../utils/toastMessage";

const FeedbackModal: React.FC = (props: any) => {
  const questions = !!props.feedbackQuestions ? props.feedbackQuestions : [];
  const [active_feed, setActive] = React.useState("");
  const [active_QA, setActiveQA] = React.useState([] as any);
  const [ansArr, setAnsArr] = React.useState([] as any);
  const [toast, setToast] = React.useState({
    showToast: false,
    toastMessage: "",
    severity: "",
  });

  const { goBack = () => null } = props;

  // useEffect(()=>{
  //   if(!!questions && !!questions[Number(active_feed)-1] && !!questions[Number(active_feed)-1].feedbackItems){
  //    setActiveQA(questions[Number(active_feed)-1].feedbackItems || []);
  //   }
  // },[ansArr]);
  useEffect(() => {
    if (!!props.savedFeedback && !!props.savedFeedback.rating) {
      const { rating, responses } = props.savedFeedback;
      setActive(rating + "");
      setAnsArr([...responses]);

      // console.log("questions ======", questions);
      if (!!questions) {
        // if (questions.length <= Number(rating) - 1) {
        // setActiveQA(questions[questions.length - 1].feedbackItems);
        // }

        setActiveQA(questions[Number(rating) - 1].feedbackItems);
      }
    } else {
      setActive("");
      setAnsArr([]);
      setActiveQA([]);
    }
  }, [props.savedFeedback]);

  const feedArr = [
    { img: "/images/below_avg.svg", id: "1", title: "BELOW AVG" },
    { img: "/images/avg.svg", id: "2", title: "AVERAGE" },
    { img: "/images/ok.svg", id: "3", title: "GOOD" },
    { img: "/images/good.svg", id: "4", title: "VERY GOOD" },
    { img: "/images/super.svg", id: "5", title: "EXCELLENT" },
  ];

  const saveAns = (ans: any, ele: any, ind: number) => {
    const obj = {
      feedbackItemId: ele.feedbackItemId,
      response: ans,
    };
    ansArr[ind] = obj;
    setAnsArr([...ansArr]);
  };

  const submitFeedback = async () => {
    if (!!active_feed) {
      if (ansArr.filter((ele: any) => ele).length === active_QA.length) {
        const payload = {
          rating: active_feed,
          responses: ansArr,
        };
        const res = await props.saveFeedback(props.bookingId, payload);
        if (res.status === "SUCCESS") {
          await props.fetchBookings();
          props.close();
          goBack();
        }
      } else {
        setToast({
          showToast: true,
          toastMessage: "Please answer all questions",
          severity: "warning",
        });
      }
    } else {
      setToast({
        showToast: true,
        toastMessage: "Please select rating",
        severity: "warning",
      });
    }
  };

  const setFeedback = (item: any, ind: number) => {
    setActive(item.id);
    setAnsArr([]);

    // console.log("Question =====", questions);
    if (!!questions) {
      // if (questions.length < ind) {
      setActiveQA(questions[ind].feedbackItems || []);
      // }
    }
  };

  return (
    <div>
      <IonModal
        isOpen={props.visible}
        backdropDismiss={true}
        onDidDismiss={() => {
          setActive("");
          setAnsArr([]);
          setActiveQA([]);
          props.close();
        }}
        cssClass="confirm_picker-modal feedback_modal"
      >
        <div className="main_container">
          <IonRow className="feedback_header_div">
            <IonLabel className="feedback_heading">Share your feedback</IonLabel>
            <img
              className="close_icon"
              src="/images/close_popup.svg"
              onClick={() => {
                props.clearSavedFeedbackStatus();
                props.close();
              }}
            />
          </IonRow>
          <div className={props.savedFeedback ? "question-feedback" : "question_scroll"}>
            <div className="quality_service">Quality of Service</div>
            <IonRow className="space-between">
              {feedArr.map((ele: any, ind: number) => (
                <div
                  key={ind}
                  className="img-div"
                  onClick={() =>
                    !!props.savedFeedback ? console.error("You cannot edit") : setFeedback(ele, ind)
                  }
                >
                  <img
                    src={ele.img}
                    key={ind}
                    style={{
                      cursor: !!props.savedFeedback ? "default" : "pointer",
                    }}
                    className={ele.id === active_feed ? "active_img" : "inactive_img"}
                  />
                  {ele.id === active_feed && (
                    <IonLabel className="text_style">{ele.title}</IonLabel>
                  )}
                </div>
              ))}
            </IonRow>

            {active_QA.length > 0 &&
              active_QA.map((ele: any, index: number) => (
                <>
                  <div key={index} className="question_style">
                    {index + 1}. {ele.text}
                  </div>
                  <div className="button_container">
                    {[{ label: "Yes" }, { label: "No" }].map((item: any) => (
                      <div
                        style={
                          !!ansArr[index] &&
                          !!ansArr[index].response &&
                          ansArr[index].response === item.label
                            ? { cursor: "default" }
                            : !!props.savedFeedback
                            ? { backgroundColor: "#dddddd", cursor: "default" }
                            : {}
                        }
                        className={
                          !!ansArr[index] &&
                          !!ansArr[index].response &&
                          ansArr[index].response === item.label
                            ? "active_feedback_btn_style"
                            : "feedback_btn_style"
                        }
                        onClick={() =>
                          !!props.savedFeedback
                            ? console.error("You cannot edit")
                            : saveAns(item.label, ele, index)
                        }
                      >
                        {item.label}
                      </div>
                    ))}
                  </div>
                </>
              ))}
          </div>
          {!props.savedFeedback && (
            <div className="btn_center">
              <IonButton className="submit_btn" color="primary" onClick={() => submitFeedback()}>
                Submit
              </IonButton>
            </div>
          )}
        </div>
      </IonModal>
      <ToastMessage
        showToast={toast.showToast}
        ToastMessage={toast.toastMessage}
        severity={toast.severity}
        onDidDismiss={() => {
          setToast({
            showToast: false,
            toastMessage: "",
            severity: "",
          });
        }}
      />
    </div>
  );
};
export default connect(
  ({ booking }: any) => {
    const { feedbackQuestions, savedFeedback } = booking;
    return { feedbackQuestions, savedFeedback };
  },
  {
    saveFeedback,
    fetchBookings,
    clearSavedFeedbackStatus,
  },
)(FeedbackModal);
